/**
 * Kept apart from `regionAvailability` because `src/api` reaches this through `RegionProvider`:
 * neither this file nor anything it imports may pull in UI modules.
 */
import { REGION_KEY } from 'shared/components/RegionSwitcher/constants';
import { resolveRegion } from 'shared/components/RegionSwitcher/regionSessionStorage';
export var getRegionFromSearch = function getRegionFromSearch(search) {
    return resolveRegion(new URLSearchParams(search).get(REGION_KEY));
};
